import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ControlTypes } from '@nx-customer-apps/shared/enums';
import { MultiQuestionbox, TypesHTMLHelper } from '@nx-customer-apps/shared/utils';

@Component({
    selector: 'vp-multi-questionbox',
    templateUrl: './multi-questionbox.component.html',
    styleUrl: './multi-questionbox.component.scss',
    standalone: false
})
export class MultiQuestionboxComponent {
    @Input() form: FormGroup;
    @Input() question: MultiQuestionbox;
    readonly CONTROL_TYPES: typeof ControlTypes = ControlTypes;
    readonly TYPES = TypesHTMLHelper;
}
